/*
  Triftlin – orientační cena přístupů v Kč (Česko) a € (Slovensko).
  Jen na stránce Access Tiers: pod dolarovou cenou přidá „≈ 239 Kč“ / „≈ 9,82 €“. Ostatní země nevidí nic.
  Kurzy se nastavují v editoru tématu: Nastavení tématu → Triftlin – kurzy.
*/
(() => {
  const rates = window.TriftlinRates || {};
  const targets = document.querySelectorAll(
    '.offrack-access-tiers .tcard-head .price, .offrack-access-tiers .row-footer .p'
  );
  if (!targets.length) return;

  const currencyFor = (country) => {
    if (country === 'CZ' && rates.czk > 0) return { rate: rates.czk, format: (v) => `≈ ${Math.round(v).toLocaleString('cs-CZ')} Kč` };
    if (country === 'SK' && rates.eur > 0) {
      return { rate: rates.eur, format: (v) => `≈ ${v.toLocaleString('sk-SK', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €` };
    }
    return null;
  };

  const render = (country) => {
    const currency = currencyFor(country);
    if (!currency) return;
    targets.forEach((el) => {
      if (el.querySelector('.tl-local-price')) return;
      const match = el.textContent.match(/\$\s?(\d+(?:[.,]\d+)?)/);
      if (!match) return;
      const usd = parseFloat(match[1].replace(',', '.'));
      const note = document.createElement('span');
      note.className = 'tl-local-price';
      note.textContent = currency.format(usd * currency.rate);
      el.appendChild(note);
    });
  };

  let cached = null;
  try {
    cached = sessionStorage.getItem('tl-country');
  } catch (e) {}

  if (cached) {
    render(cached);
  } else {
    fetch('/browsing_context_suggestions.json')
      .then((r) => r.json())
      .then((data) => {
        const country = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        if (!country) return;
        try {
          sessionStorage.setItem('tl-country', country);
        } catch (e) {}
        render(country);
      })
      .catch(() => {});
  }
})();
